import $ from 'jquery';
import React,{useEffect} from 'react';
import {GetImgCertUser_CBack,appGetUrlPath,TableDatePicker} from '../function_lib/common_lib';
// import Comp_Stylus_Pen from './comp_stylus_pen';
import {Custom_Alert,Alert_Content} from '../components/custom_alert';
import StylusCanvas from './comp_stylus';

import pdfIcon from '../assets/images/pdf_icon.png';
import mp3Icon from '../assets/images/mp3_icon.png';
import mp4Icon from '../assets/images/mp4_icon.png';

export function submitOfficialSign(){
  
    GetImgCertUser_CBack(this,"#frmTaskOfficerSign","officialSignAprTask",function(checkData,checkMsg,userMsg){
          if(checkData===-10){
            
            Custom_Alert("Validation","Kindly fill required fields",false);
            return;
          }else {
            //Custom_Alert("Successfully Added",checkMsg,false);
            
            Custom_Alert("View",checkMsg,false);
            $('#divEditStudyMaterial').modal('hide');
            //window.location.reload();
          }
        });
  }
export const Comp_Task_Officer_Sign=(props)=>{
  
  const getLatestDraw=(bImg)=>{
    //alert(bImg);
    $("#style_drwa_officer").val(bImg);
  }
  let appUrl=appGetUrlPath();

  if(window.memc_system){
   appUrl="http://localhost:8080/memb_c/getFileAsPerPath";
  }

   useEffect(()=>{
    //alert(JSON.stringify(props.proItem));
    //alert("image name=="+props?.proItem?.answers_attch);
   },[props.proItem])
        return(<div className="modal fade bd-example-modal-xl"  id="divTaskOfficerSign" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xxl" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">{(typeof props.proItem!=="undefined" && typeof props.proItem.category_name!=="undefined")?"("+props.proItem.main_category+") "+props.proItem.category_name:''}</h5>
              <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            <form id="frmTaskOfficerSign" name="frmTaskOfficerSign" enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()">
            <input type='hidden' name="curl_type" id="curl_type" value={"officialSignAprTask"}/>
            <input type="hidden" name="m_type" id="m_type" value={"officialSignAprTask"} />
            
            <input type="hidden" id="global_token" name="global_token" value={props.userObject[0]["id"]}/>
            <input type="hidden" id="local_token" name="local_token" value={props.userObject[0]["id"]}/>
            <input type="hidden" id="study_material_id" name="study_material_id" value={typeof props.proItem!=="undefined"?btoa(props.proItem.id):'0'} />
            <input type="hidden" id="cadet_task_id" name="cadet_task_id" value={typeof props.proItem!=="undefined"?btoa(props.proItem.cadet_task_id):'0'}/>

            <input type="hidden" name="lsBookTumb" id="lsBookTumb" />
            <input type="hidden" name="style_drwa_officer" id="style_drwa_officer"/>
                 

           
            <div className="modal-body">
                {typeof props.proItem!=="undefined"?
            <div className="row">
                      {/* <!-- left column --> */}
                      <div className="col-md-12">
                          <div className="card card-danger">
                                   <div className="card-body">
                                    <h5>{"Test your knowledge"}</h5>
                                    <h6>{typeof props.proItem!=="undefined"?props.proItem["specifications"]:''}</h6>
                                    <div id="div_answers_txt">
                                        <br/>
                                        <h6>{"Answers by student"}</h6>
                                        {props.proItem["answers_txt"]}
                                    </div>
                                    {window?.memc_system?<div>
                                      <div id="div_answer_attachments">
                                      {/* {appUrl+"?file_nm="+props.proItem["answers_attch"]} */}
                                      {props.proItem["answers_attch"]!==""?<div class="row">
                                        <div className='col-md-4'>
                                        <img class="w-100" src={appUrl+"?file_nm="+props.proItem["answers_attch"]}  />
                                        </div>
                                        </div>:''}
                                    </div>
                                    <div id="div_answer_attachments">
                                    {/* {appUrl+"?file_nm="+props.proItem["answ_draw"]} */}
                                      {props.proItem["answ_draw"]!==""?<img src={appUrl+"?file_nm="+props.proItem["answ_draw"]}  />:''}
                                    </div>

                                    </div>:
                                    <div>
                                      <div id="div_answer_attachments">
                                    {props.proItem["answers_attch"]!==""?<img src={appUrl+"test_stu_task_upd/"+props.proItem["answers_attach"]}  />:''}
                                  </div>
                                  <div id="div_answer_attachments">
                                    {props.proItem["answ_draw"]!==""?<img src={appUrl+"test_stu_task_upd/"+props.proItem["answ_draw"]}  />:''}
                                  </div>
                                      
                                      </div>}
                                    
                                   
                                    
                                      <div className="col-md-6 respSSL"></div>
                                      <div id="testing2dd2222"></div>
                                  </div>
                              
                          </div>
                      </div>
                      </div>:''}
                     
                      <div class="row">
                      <div className='col-md-6 col-sm-12'>
                      <label>Officer's Signature:</label>
                                    <StylusCanvas latestDraw={getLatestDraw}/>
                      
                     
                      </div>
                      <div className='col-md-4 col-sm-12'>
                       <label>Officer's Code (*)</label>
                       <input type="password" id="officers_code" name="officers_code" class="form-control" />
                      </div>
                      <div className='col-md-1'>
                     
                      </div>

                      
                  </div>
                  <div class="row">
                    <div class="col-12">
                    <div onClick={()=>submitOfficialSign()}  style={{marginRight:"10px"}} id="btnCatSearch" name="btnCatSearch" className="  bottom-fixed btn btn-sm btn-danger">Submit Approval</div>
                    </div>
                  </div>
            </div>
            <div className="modal-footer mb-5">
            
                 {/* <div onClick={()=>this.resetFilters()} className="btn btn-sm btn-primary">STO Approve</div> */}
            <div id="getReponse" style={{color:"red"}}></div>
             
            </div>
            </form>
          </div>
          </div>
          </div>
      );
    
}
export default Comp_Task_Officer_Sign;
